import React from 'react';
import { motion } from 'framer-motion';
import RealTimeInsightPreview from '../home/RealTimeInsightPreview';

const Slide04RealTime: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-full px-16">
      <div className="flex items-center gap-16 max-w-6xl">
        {/* Left: Text content */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          className="flex-1"
        >
          <h2 className="text-5xl font-bold text-white mb-6">
            Real-Time Updates for Everyone
          </h2>
          <p className="text-2xl text-[#94a3b8] mb-8 leading-relaxed">
            Every answer a student gives instantly updates dashboards for all stakeholders.
          </p>
          <div className="space-y-5">
            {[
              { emoji: '🎓', label: 'Students', desc: 'See their progress and earn XP instantly' },
              { emoji: '👩‍🏫', label: 'Teachers', desc: 'Get real-time class insights and alerts' },
              { emoji: '👨‍👩‍👧', label: 'Parents', desc: 'Stay informed without waiting for reports' },
            ].map((item, i) => (
              <motion.div
                key={item.label}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.3 + i * 0.1 }}
                className="flex items-center gap-4"
              >
                <span className="text-3xl">{item.emoji}</span>
                <div className="text-xl">
                  <span className="font-semibold text-white">{item.label}:</span>
                  <span className="text-[#94a3b8] ml-2">{item.desc}</span>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Right: Preview component */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="w-[380px] flex-shrink-0"
        >
          <RealTimeInsightPreview />
        </motion.div>
      </div>
    </div>
  );
};

export default Slide04RealTime;
